import * as React from "react";
import { Card, Icon, Label, Accordion } from "semantic-ui-react";

type RecordCardProps = {
  record: State.RecordMeta | null;
  viewJson: string | null;
  isFetching: boolean;
  fetchError: string | null;
  title: string;
};

type RecordCardState = {
  isJsonExpanded: boolean;
};

class RecordCard extends React.Component<RecordCardProps, RecordCardState> {
  state: RecordCardState = {
    isJsonExpanded: false,
  };

  private toggleJson = (): void => {
    this.setState((prev) => ({ isJsonExpanded: !prev.isJsonExpanded }));
  };

  render(): JSX.Element {
    const { record, viewJson, isFetching, fetchError, title } = this.props;
    const { isJsonExpanded } = this.state;

    if (isFetching) {
      return (
        <Card fluid>
          <Card.Content>
            <Card.Header>{title}</Card.Header>
            <Card.Description>
              <Icon name="spinner" loading /> Loading...
            </Card.Description>
          </Card.Content>
        </Card>
      );
    }

    if (fetchError) {
      return (
        <Card fluid>
          <Card.Content>
            <Card.Header>{title}</Card.Header>
            <Card.Description>
              <Label color="red" basic>
                <Icon name="warning sign" /> {fetchError}
              </Label>
            </Card.Description>
          </Card.Content>
        </Card>
      );
    }

    if (!record) {
      return (
        <Card fluid>
          <Card.Content>
            <Card.Header>{title}</Card.Header>
            <Card.Description>
              <Label basic>No record found</Label>
            </Card.Description>
          </Card.Content>
        </Card>
      );
    }

    return (
      <Card fluid>
        <Card.Content>
          <Card.Header>{title}</Card.Header>
          <Card.Meta>
            <span>ID: {record.id}</span>
          </Card.Meta>
          <Card.Description>
            <p>
              <Icon name="clock outline" /> {new Date(record.savedAt).toLocaleString()}
            </p>
            <p>
              <Icon name="user" /> {record.savedBy}
            </p>
          </Card.Description>
        </Card.Content>
        {viewJson && (
          <Card.Content extra>
            <Accordion>
              <Accordion.Title active={isJsonExpanded} onClick={this.toggleJson}>
                <Icon name="dropdown" />
                View JSON
              </Accordion.Title>
              <Accordion.Content active={isJsonExpanded}>
                <pre style={{ maxHeight: "300px", overflow: "auto", fontSize: "11px" }}>
                  {viewJson}
                </pre>
              </Accordion.Content>
            </Accordion>
          </Card.Content>
        )}
      </Card>
    );
  }
}

export default RecordCard;
